import { Col, Container, Row } from "react-bootstrap";
import {
  Button,
  Checkbox,
  Group,
  IconHouseHeart,
  IconImageEditView,
  IconPencil,
  IconPlus,
  IconStar,
  IconTrash,
  Modal,
  Search,
  Table,
  TextBox,
  useToast,
} from "@veneer/core";
import { useState, useEffect, useRef } from "react";
import React from "react";
import { POST_C_AND_W_PAGELOAD, POST_FAVOURITES } from "../../../services";
import { apiPost } from "../../../services/service";
import Product_warranty_modal from "../modal/contactandwarranties-modal/product-warranty-modal";
import Exporttoexcel from "../case-homepage/cases/exporttoexcel";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./contracts-warranties.scss";
import { useTranslation } from "react-i18next";
import Loader from "../shared-components/loader/loader";
import { use } from "i18next";
import { POST_ROW_DELETE, POST_ROW_UPDATE } from "@constants/end-points";
import { useAppDispatch } from "@store/hooks";
import { setLoading } from "@store/reducers/loadingSlice";
import { handleErrorResponse } from "utils";
import EditAction from "./edit-action/edit-action";

// const handleNameFilter = (value: any) => setNameValue(value);

export const ContractsWarranties = () => {
  const { addToast } = useToast();
  const { t } = useTranslation();
  const items: any[] | (() => any[]) = [];
  const sortedColomn = [
    "serialnumber",
    "productname",
    "statuscode",
    "status",
    "expirationdate",
    "siteaccount",
    "nickname",
    "favourite",
  ];

  const editOption = [
    'Edit Nick Name'
  ]
  const [showfavonly, setShowfavonly] = useState<boolean>(false);
  const [progress, setProgress] = useState(false);
  const [tableLoading, setTableLoading] = useState<boolean>(true);
  const [value, setValue] = useState<any>([]);
  const [options, setOptions] = useState(items);
  //const onChange = (selectedOption) => setValue([selectedOption.value]);
  const onClear = () => setValue([]);
  const [isChecked, setIsChecked] = useState(false);

  const [hasClearAllFilters, setHasClearAllFilters] = React.useState(false);
  const [orderBy, setOrderBy] = useState("name");
  const [orderType, setOrderType] = useState("ascending");

  const [error, setError] = useState("");
  // const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [option, setOption] = useState([]);
  const [P_WModal, setP_WModal] = useState(false);
  const [modalKey, setmodalKey] = useState(0);
  const [warrantyPageload, setWarrantyPageload] = useState<any>();
  const [openEditOptionPopup, setOpenEditOptionPopup] = useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  const [selectedRowItem, setSelectedRowItem] = useState<{}>({});
  const [selectedNickName, setSelectedNickName] = useState('')
  const [actionType, setActionType] = React.useState(0);
  const dispatch = useAppDispatch();
  // const [order, setOrder] = React.useState(sortedColomn);
  const [nameValue, setNameValue] = useState("");
  const handleNameFilter = (value: any) => setNameValue(value);
  const clearOtherFliter = (name: string) => {
    switch (name) {
      case "serialnumber":
        setProductValue("");
        setStatusValue("");
        setSiteaccountValue("");
        setExpirationdateValue("");
        setNicknameValue("");
        setEntitlement_typeValue("");
        break;
      case "productname":
        setSeriaiValue("");
        setStatusValue("");
        setSiteaccountValue("");
        setExpirationdateValue("");
        setNicknameValue("");
        setEntitlement_typeValue("");
        setShowfavonly(false);

        break;
      case "status":
        setSeriaiValue("");
        setProductValue("");
        setSiteaccountValue("");
        setExpirationdateValue("");
        setNicknameValue("");
        setEntitlement_typeValue("");
        break;
      case "SiteaccountValue":
        setSeriaiValue("");
        setProductValue("");
        setStatusValue("");
        setExpirationdateValue("");
        setNicknameValue("");
        setEntitlement_typeValue("");
        break;
      case "ExpirationdateValue":
        setSeriaiValue("");
        setProductValue("");
        setStatusValue("");
        setSiteaccountValue("");
        setNicknameValue("");
        setEntitlement_typeValue("");
        break;
      case "NicknameValue":
        setSeriaiValue("");
        setProductValue("");
        setStatusValue("");
        setSiteaccountValue("");
        setExpirationdateValue("");
        setEntitlement_typeValue("");
        break;
      case "Entitlement_typeValue":
        setSeriaiValue("");
        setProductValue("");
        setStatusValue("");
        setSiteaccountValue("");
        setExpirationdateValue("");
        setNicknameValue("");
        break;
      case "Showfavonly":
        setSeriaiValue("");
        setProductValue("");
        setStatusValue("");
        setSiteaccountValue("");
        setExpirationdateValue("");
        setNicknameValue("");
        setEntitlement_typeValue("");
        break;
    }
  };
  const [serialValue, setSeriaiValue] = useState("");


  const handleSerialFilter = (value: any) => {
    setSeriaiValue(value);
    clearOtherFliter("serialnumber");
    let filtered: any = filteredData.filter((item: any) =>
      item.serialnumber.props.children
        .toLowerCase()
        .includes(value.trim().toLowerCase())
    );
    setData(filtered);
  };


  const popupHeader = (popupTilte: string) => {
    return (
      <p className="popup-header">
        <img
          src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
          alt=""
          style={{ height: "46px", width: "auto" }}
        />
        <span>{popupTilte}</span>
      </p>
    );
  };

  const [productValue, setProductValue] = useState("");
  const handleProductFilter = (value: any) => {
    clearOtherFliter("productname");
    setProductValue(value);
    let filtered: any = filteredData.filter((item: any) =>
      item.productname.toLowerCase().includes(value.toLowerCase())
    );
    setData(filtered);
  };


  const hidEditPopup = () => {
    const editPopup = document.getElementsByClassName("edit-option-popup");
    for (let row of editPopup) {
      row.classList.remove("active");
    }
  }

  const okHandler = async (type: any) => {
    setOpen(false);
    closeHandler();
    dispatch(setLoading(true));
    const payload = {
      ...selectedRowItem,
      'nickname':selectedNickName,
      "isRowSelected": true,
      "Delete": false,
      "selectedtab": "2",
      "lcid": "1033",
      "datalang": "en-US"
    }

    try {
      const response: any = await apiPost(type === 2 ? POST_ROW_DELETE : POST_ROW_UPDATE, payload);
      dispatch(setLoading(false));
      if (response?.status === 200) {
        toast.success(response?.data.successmessage);
        fetchData();
      } else {
        handleErrorResponse(response);
      }
    } catch (error: any) {
      handleErrorResponse(error);
    }
  }

  const closeHandler = () => {
    document.querySelectorAll('.edit-option-popup.active').forEach((popup) => {
      popup.classList.remove('active');
    });
  }

  const [statusValue, setStatusValue] = useState("");
  const handleStatusFilter = (value: any) => {
    setStatusValue(value);
    clearOtherFliter("status");
    let filtered: any = filteredData.filter((item: any) =>
      item.status.toLowerCase().includes(value.toLowerCase())
    );
    setData(filtered);
  };

  const [siteaccountValue, setSiteaccountValue] = useState("");
  const handleSiteaccountFilter = (value: any) => {
    setSiteaccountValue(value);
    clearOtherFliter("SiteaccountValue");
    let filtered: any = filteredData.filter((item: any) =>
      item.siteaccount.toLowerCase().includes(value.toLowerCase())
    );
    setData(filtered);
  };

  const [expirationdateValue, setExpirationdateValue] = useState("");
  const handleExpirationdateFilter = (value: any) => {
    setExpirationdateValue(value);
    clearOtherFliter("ExpirationdateValue");
    let filtered: any = filteredData.filter((item: any) =>
      item.expirationdate.toLowerCase().includes(value.toLowerCase())
    );
    setData(filtered);
  };

  const [nicknameValue, setNicknameValue] = useState("");
  const handleNicknameFilter = (value: any) => {
    clearOtherFliter("NicknameValue");
    setNicknameValue(value);
    let filtered: any = filteredData.filter((item: any) =>
      item.nickname.toLowerCase().includes(value.toLowerCase())
    );
    setData(filtered);
  };

  const [entitlement_typeValue, setEntitlement_typeValue] = useState("");
  const handleEntitlement_typeFilter = (value: any) => {
    clearOtherFliter("Entitlement_typeValue");
    setEntitlement_typeValue(value);
    let filtered: any = filteredData.filter((item: any) =>
      item.Entitlement_type.toLowerCase().includes(value.toLowerCase())
    );
    setData(filtered);
  };

  const navigate = useNavigate();
  const onChange = (selectedOption: any) => setValue([selectedOption.value]);
  const openModal = () => {
    setmodalKey((prevKey) => prevKey + 1);
    setP_WModal(true);
    fetchData();
  };
  const closeModal = () => {
    setP_WModal(false);
  };

  const handleOnlyFevList = (e: any) => {
    setIsChecked(!isChecked);
    clearOtherFliter("Showfavonly");
    setShowfavonly(isChecked);
    setTableLoading(true);
    fetchData(!isChecked);
  };



  const favIconFill = (caseId: string) => {
    return (
      <Button
        onClick={(e) => handleFev(caseId, "OFF", e)}
        appearance="ghost"
        leadingIcon={<IconStar filled size={40} />}
      />
    );
  };

  const favIcon = (caseId: string) => {
    return (
      <Button
        onClick={(e) => handleFev(caseId, "ON", e)}
        appearance="ghost"
        leadingIcon={<IconStar size={40} />}
      />
    );
  };

  const handleFev = async (caseId: string, state: string, e: any) => {
    try {
      setProgress(true);
      let payload = {
        key: "favourite_contracts",
        state: `${state}`, //"ON",//OFF
        contactid: "85680c15-7814-e711-80fc-5065f38ad971",
        id: `${caseId}`,
        
        
      };
      const fev = await apiPost(POST_FAVOURITES, payload);
      if (fev?.data) {
        fetchData();
        setIsChecked(false);
      } else {
        console.error("No data found in response");
      }
    } catch (error) {
      return false;
    }
  };

  const columns = [
   

    {
      id: "serialnumber",
      label: t("HPI.ContractWarranties.ExtendedWarrantyTab.SerialNumber", {
        defaultValue: "Serial Number",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          value={serialValue}
          //onInput={searchData}
          onClear={() => setSeriaiValue("")}
          onChange={handleSerialFilter}
        />
      ),
    },
    {
      id: "productname",
      label: t("HPI.ContractWarranties.ExtendedWarrantyTab.ProductName", {
        defaultValue: "Product Name",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          value={productValue}
          onClear={() => setProductValue("")}
          onChange={handleProductFilter}
        />
      ),
    },
    {
      id: "status",
      label: t("HPI.ContractWarranties.ExtendedWarrantyTab.Status", {
        defaultValue: "Status",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          value={statusValue}
          onClear={() => setStatusValue("")}
          onChange={handleStatusFilter}
        />
      ),
    },
    {
      id: "expirationdate",
      label: t("HPI.ContractWarranties.ExtendedWarrantyTab.ExpirationDate", {
        defaultValue: "Expiration Date",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          value={expirationdateValue}
          onClear={() => setExpirationdateValue("")}
          onChange={handleExpirationdateFilter}
        />
      ),
    },
     !window.IsIndividualRole &&  
    {
      id: "siteaccount",
      label: t("HPI.ContractWarranties.ExtendedWarrantyTab.SiteAccount", {
        defaultValue: "Site Account",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          value={siteaccountValue}
          onClear={() => setSiteaccountValue("")}
          onChange={handleSiteaccountFilter}
        />
      ),
    },
    {
      id: "Entitlement_type",
      label: t('HPI.Contractwarranties.Entitlementtype',{defaultValue:'Entitlement type'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          value={entitlement_typeValue}
          onClear={() => setEntitlement_typeValue("")}
          onChange={handleEntitlement_typeFilter}
        />
      ),
    },
    {
      id: "nickname",
      label: t("HPI.ContractWarranties.ExtendedWarrantyTab.NickName", {
        defaultValue: "Nick Name",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          value={nicknameValue}
          onClear={() => setNicknameValue("")}
          onChange={handleNicknameFilter}
        />
      ),
    },
    {
      id: "favourite",
      label: t("HPP.MainHomePage.FavoriteHeadertext", {
        defaultValue: "Favorite",
      }),
      filter: (
        <Checkbox
          id="checkbox"
          checked={isChecked}
          label={t("HPI.ShowMyFavouriteCW", {
            defaultValue: "Show Favorites Only",
          })}
          onChange={(e: any) => handleOnlyFevList(e)}
        />
      ),

    },
    {
      id: "edit",
      label: t('HPI.EditCase.casesubmitted.Actions',{defaultValue:'Action'})
    },

  ];

  const handleOnClearAllFilters = () => { };
  const clickOndata = (data: any, btnName: any) => {
    let uri = `ainfo=${data.serialnumber}&pno=${data.productname}`;
    // ainfo=${data.AssertSerialNumber}&pno=${data.Product.ProductId}
    if (data.Entitlement_code === "2") {
      return (
        <button
          className="link"
          onClick={() => {
            navigate(`/product-details${data.createcaseurl}&ctyp=ew`);
          }}
        >
          {btnName}
        </button>
      );
    } else {
      return (
        <button
          className="link"
          onClick={() => {
            navigate(`/product-details${data.createcaseurl}&ctyp=wr`);
          }}
        >
          {btnName}
        </button>
      );
    }
  };

  const fetchData = async (showfavonlyopt = false) => {
    setLoading(true);
    setProgress(true);
    setError("null");
    try {
      let payload = {
        contactid: "85680C15-7814-E711-80FC-5065F38AD971",
        parentcustomerid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
        selectedtab: "2",
        ddlFilterStatusSelected: "",
        showfavonly: showfavonlyopt,
        ddlFilterbysiteaccountSelected: "",
        
        
      };
      let payload2 = {
        contactid: "85680C15-7814-E711-80FC-5065F38AD971",
        showfavonly: showfavonlyopt,
        parentcustomerid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
        selectedtab: "4",
        ddlFilterStatusSelected: "",
        ddlFilterbysiteaccountSelected: "",
        
        
      };
      try {
        const response = await apiPost(POST_C_AND_W_PAGELOAD, payload);
        if (response.data) {
          const data = response.data;
          const BindCarePackGrid = JSON.parse(data.BindCarePackGrid);
          const ddlCarepackSiteAccount = JSON.parse(
            data.ddlCarepackSiteAccount
          );
          try {
            const sendapi = await apiPost(POST_C_AND_W_PAGELOAD, payload2);
            if (sendapi.data) {
              const data2 = sendapi.data;
              const manufacturerWarranty = JSON.parse(data2.BindProductsGrid);
              const bothdata: any = mergeAndAddKey(
                BindCarePackGrid,
                manufacturerWarranty
              );
              setWarrantyPageload(data);
              const xlRows: any = bothdata?.map((item: any) => {
                const row: any = {
                  "Serial Number": item.serialnumber,
                  "Product Name": item.productname,
                  Status: item.status,
                  "Expiration Date": item.expirationdate,
                  "Entitlement type": item.Entitlement_type,
                  "Nick Name": item.nickname,
                  Favourite: item.favourite,
                };

                // Conditionally add the "Site Account" key
                if (!window.IsIndividualRole) {
                  row["Site Account"] = item.siteaccount;
                }
                return row;
              });

              setExportData(xlRows);
              const formattedData: any = bothdata?.map((item: any) => ({
                serialnumber: clickOndata(item, item.serialnumber),
                productname: item.productname,
                status: item.status,
                expirationdate: item.expirationdate,
                siteaccount: item.siteaccount,
                nickname: item.nickname,
                Entitlement_type: item.Entitlement_type,
                favourite:
                  item.favourite === "true"
                    ? favIconFill(item.Contractguid)
                    : favIcon(item.Contractguid),
                edit: (
                  <EditAction
                    item={item}
                    setSelectedRowItem={(item: any) =>
                      setSelectedRowItem(item)
                    }
                    setSelectedNickName={(item: any) =>
                      setSelectedNickName(item)
                    }
                    setOpen={(item: any) => setOpen(item)}
                    setActionType={(item: any) => setActionType(item)}
                  />
                ),
              }));


              setTableLoading(false);
              const formatted_site_account = JSON.parse(
                data.ddlCarepackSiteAccount
              ).map((item: any) => ({
                value: item.Value,
              }));
              setData(formattedData);
              setFilteredData(formattedData);
              setOption(formatted_site_account);
              setProgress(false);
            } else {
              setProgress(false);
              setTableLoading(false);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setProgress(false);
          setTableLoading(false);
        }
      } catch (error) {
        setProgress(false);
        setTableLoading(false);
      }
    } catch (err) {
      setError("Failed ");
      setLoading(false);
      setProgress(false);
      setTableLoading(false);
    }
  };

  const mergeAndAddKey = (array1: any, array2: any) => {
    const updatedArray1 = array1.map((item: any) => ({
      ...item,
      Entitlement_type: t(
  "HPI.Contractwarranties.extendedwarranty",
  { defaultValue: "Extended warranty" }
),
      Entitlement_code: "2",
    }));
    const updatedArray2 = array2.map((item: any) => ({
      ...item,
      Entitlement_type: t(
  "HPI.Contractwarranties.products",
  { defaultValue: "Manufacturer warranty" }
),
      Entitlement_code: "4",
    })); //Manufacturer warranty
    return [...updatedArray1, ...updatedArray2];
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container fluid>
      <div className="contracts-warranties">
        {progress && (
          <div className="loader-overlay">
            <div className="loader-css">
              <Loader />
            </div>
          </div>
        )}
        <div className="header">
          <h2>
            {t("HPI.MainHomePage.UpperList.Contract", {
              defaultValue: "Contracts and Warranties",
            })}
          </h2>
        </div>
        <Container className="card-container">
          <Row>
            <Col className="content">
              <div
                dangerouslySetInnerHTML={{
                  __html: t("HPI.Contractwarranties.Contractwarranties", {
                    defaultValue: `<h2>My contracts and warranties</h2>\r\n<p>This page lists the support agreements, HP extended warranty and warranties linked to your user ID or shared with you by another user. Choose an item in the list to view its entitlement details. <a href=\"http://www.hp.com/support/mycrmhelp\" target=\"_blank\">Read about HP entitlements.</a></p>`,
                  }),
                }}
              ></div>
            </Col>
          </Row>
        </Container>
        <Container fluid className="detail-container">
          <Row>
            <Col>
              <p className="mb-4 mt-4">
                {t("HPI.Contractwarranties.ExtendedWarrantyDescription", {
                  defaultValue:
                    "An extension of the coverage period on the Manufacturer warranty. An extended warranty (HP Care Pack), increases the time period that HP will offer various types of warranty support services.",
                })}
                <br />
                {t("HPI.Contractwarranties.Totalextendedwarranty", {
                  defaultValue: "Total Warranty :",
                })}{" "}
                {data.length}
              </p>
            </Col>
          </Row>
          <Row className="mb-4 mt-4">
            <Col md={3}></Col>
            <Col md={4} className="align-item-last"></Col>

            <Col md={5} className="align-item-last">
              <Button
                onClick={openModal}
                style={{ marginRight: "15px" }}
                leadingIcon={<IconPlus />}
              >
                {t("HPI.Contractwarranties.warrantyAddnewproduct", {
                  defaultValue: "Add new product warranty",
                })}
              </Button>
              <Exporttoexcel
                fileName="My Contracts and Warranties"
                rows={exportData}
              />
            </Col>
          </Row>
          <Row>
            <Col className="table-container">
              <Table
                showFilters
                loading={tableLoading}
                columns={columns as any}
                data={data as any}
                loadingDataLength={5}
                onClearAllFilters={handleOnClearAllFilters}
                // actionArea={editOption}
              //rowSelector="multiSelection"  
              />
            </Col>
          </Row>
        </Container>
        <Product_warranty_modal
          key={modalKey}
          relaodtable={fetchData}
          show={P_WModal}
          siteAccount={
            warrantyPageload ? warrantyPageload.ddlCarepackSiteAccount : []
          }
          onClose={closeModal}
        />
      </div>

      <Modal
        align="start"
        id="modal-id"
        show={open}
        onClose={() => { setOpen(false); hidEditPopup(); }}
        title={actionType === 1 ? t('HPI.Contractwarranties.Editnickname',{defaultValue:'Edit nick name'}):t('HPI.Confirm',{defaultValue:'Confirm'})}
        closeButton
        footer={(
          <Group>
            <Button onClick={()=>okHandler(actionType)}>{t('HPI.Contractwarranties.confirmContractDelete.OK',{defaultValue:'Ok'})}</Button>
            <Button appearance="secondary" onClick={() => { setOpen(false); hidEditPopup(); }}>{t('HPI.btnCancel',{defaultValue:'Cancel'})}</Button>
          </Group>
        )}
      >

        {actionType === 1 ?
          <>
            <TextBox 
              label={t('HPI.ContractWarranties.ExtendedWarrantyTab.NickName',{defaultValue:'Nick Name'})}
              separateLabel
              value={selectedNickName}
              onChange={(v:any)=>{
                if(v.length <=50){
                  setSelectedNickName(v)
                }
              }}

            ></TextBox>

          </> : <>
            <p>{t('HPI.Contractwarranties.confirmContractDelete.ConfirmQuestion', {defaultValue:'Warning!  deleting this record will remove it for all other users. Are you sure you want to delete this record?'})}</p>
            <p>{t('HPI.Contractwarranties.confirmContractDelete.ConfirmQuestionTip', {defaultValue:'Tip: use the favorites tab to show only those items you want to see.'})}</p>
          </>}

      </Modal>
    </Container>
  );
};


